import { Prisma } from '@prisma/client';

export const customerOrders: Prisma.DBCustomerOrderItemUpsertArgs[] = [];
